import { useLDClient } from '@afterpaytouch/feature'
import { Experiment, Experiments, getExperiment } from '../../model'
import { activeExperiments, useCountry, useExperiment } from '../../state'
import { isAfterpayInAppBrowser } from '../../utils/device'
import { Country } from '@afterpay/types'

export const useSocialProofExperiment = (): Experiment => {
  const name = 'CheckoutSocialProofExperiment'
  const client = useLDClient()

  const ldValue = client?.variationDetail(Experiments[name], false)
  return getExperiment(name, ldValue, activeExperiments[name], true)
}

export const useSocialBannerEligibility = (): boolean => {
  const socialProofExperiment = useSocialProofExperiment()
  const isAppSession = isAfterpayInAppBrowser()
  const experiment = useExperiment('CheckoutSocialProofExperiment', !isAppSession, socialProofExperiment)
  const country = useCountry()

  const isAUOrUS = country === Country.AU || country === Country.US
  const isValidExperimentValue = experiment?.value === 'A' || experiment?.value === 'B'

  return !isAppSession && isAUOrUS && isValidExperimentValue
}
